import * as React from 'react';

import { App, Typography } from 'antd';

import Modal from 'v2/components/Shared/Modal';
import type { IBankAccount } from 'v2/interfaces/financial';
import bankDetailsService from 'v2/services/bankDetails';

type ConfirmationModalProps = {
  isOpen: boolean;
  setClose: () => void;
  action: 'delete' | 'mainAccount' | null;
  account: IBankAccount | null;
  loadData: () => void;
};

function ConfirmationModal({ isOpen, setClose, action, account, loadData }: ConfirmationModalProps) {
  const { message } = App.useApp();
  const [loading, setLoading] = React.useState(false);

  const handleConfirmAction = async () => {
    setLoading(true);

    try {
      if (action === 'delete') {
        await bankDetailsService.deleteAccount(account?.id);
      }

      if (action === 'mainAccount') {
        await bankDetailsService.setMainAccount(account?.id);
      }

      loadData();
      setClose();
    } catch (error) {
      message.error(typeof error === 'string' ? error : 'Não foi possível concluir a ação.');
    } finally {
      setLoading(false);
    }
  };

  const confirmationText = () => {
    if (action === 'delete') {
      return (
        <Typography.Paragraph className='mb-0'>
          Tem certeza que deseja remover essa conta? Essa ação não poderá ser desfeita.
        </Typography.Paragraph>
      );
    }

    if (action === 'mainAccount') {
      return (
        <Typography.Paragraph className='mb-0'>
          Tem certeza que deseja deixar essa conta como principal? Ao confirmar, todas as transferências serão
          realizadas nessa conta.
        </Typography.Paragraph>
      );
    }

    return null;
  };

  return (
    <Modal
      size='xs'
      open={isOpen}
      textTitle={action === 'delete' ? 'Remover conta' : 'Confirmação'}
      textReturnButton='Cancelar'
      textProceedButton='Confirmar'
      setClose={setClose}
      handleProceedClick={handleConfirmAction}
      isProceedButtonLoading={loading}
    >
      {confirmationText()}
    </Modal>
  );
}

export { ConfirmationModal };
